import { routeMap } from 'router/routes';

export default function ({ serverFileName, fileName }) {
  return {
    pathname: routeMap.openLkApi,
    query: { serverFileName, filename: fileName },
  };
}
